import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'
import { TranslateFunction } from './types'
export const createClientAmlItem = createNavigationConfig((translateFn: TranslateFunction) => ({
  icon: 'amlCheckmark',
  text: translateFn('mnu_client_terrorist'),
  identity: '/secure/client/risks',
  permission: 'VIEW_CLIENT_TERRORIST',
}))

export default Loadable(() => import('./AMLClient'))
